import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const getDefaultState = () => ({
	projectId: null,
	methodId: null,
	projectRecord: null,
	methodsRecord: null
});

const storeData = {
	state: getDefaultState(),
	mutations: {
		reset(state) {
			Object.assign(state, getDefaultState());
			localStorage.clear();
		},
		setProjectId(state, id) {
			state.projectId = id;
			// Set local storage
			localStorage.setItem("projectId", id);
		},
		setProjectRecord(state, record) {
			state.projectRecord = record;
		},
		setMethodsRecord(state, record) {
			state.methodsRecord = record;
		}
	}
};

// initialise Vuex
const store = new Vuex.Store(storeData);

export default store;
